import { createSelector } from 'reselect';

const getShortLinksState = (state) => state.shortLinks;

export const getShortLinkOgTitle = createSelector(
    [getShortLinksState],
    (shortLinksState) => shortLinksState.ogTitle,
);

export const getShortLinkOgDescription = createSelector(
    [getShortLinksState],
    (shortLinksState) => shortLinksState.ogDescription,
);

export const getShortLinkOgImage = createSelector(
    [getShortLinksState],
    (shortLinksState) => shortLinksState.ogImage,
);

export const isShortLinkLoading = createSelector(
    [getShortLinksState],
    (shortLinksState) => shortLinksState.loading,
);

export const getShortLinkErrors = createSelector(
    [getShortLinksState],
    (shortLinksState) => shortLinksState.errors,
);
